import { Flex } from '@/components/atoms/Grid'
import { Body2 } from '@/components/atoms/typography'
import AnimatedExpandIcon from '@/components/atoms/animatedExpandIcon'
import styled from 'styled-components'
import { FC } from 'react'
import { SectionSeparator } from '@/components/atoms/separator'
import { validFor } from '@/theme/validFor'
import MenuBadge from '@/components/atoms/menuBadge'
import {
  Desktop,
  MediaContextProvider,
  TabletOrMobile
} from '@/components/atoms/media'

type ExpandableSectionBoxProps = {
  title: string
  onClick: () => void
  isOpened: boolean
  showBottomSeparator?: boolean
  showTopSeparator?: boolean
  mobileBadge?: string
  desktopBadge?: string
  highlight?: boolean
} & Rest

const ExpandableSectionBox: FC<ExpandableSectionBoxProps> = ({
  title,
  onClick,
  isOpened,
  showBottomSeparator = true,
  showTopSeparator = true,
  mobileBadge,
  desktopBadge,
  highlight = false,
  ...rest
}) => {
  return (
    <MenuItemWrapper onClick={onClick} {...rest}>
      {showTopSeparator && <SectionSeparator />}
      <Flex justifyContent="space-between" flexDirection="row">
        <Flex alignItems="center">
          <StyledBody2 highlight={highlight}>{title}</StyledBody2>
          <MediaContextProvider>
            <Desktop>
              {desktopBadge && (
                <MenuBadge imageUrl={desktopBadge} maxHeight={20} ml={10} />
              )}
            </Desktop>
            <TabletOrMobile>
              {(mobileBadge || desktopBadge) && (
                <MenuBadge
                  imageUrl={mobileBadge || desktopBadge}
                  maxHeight={20}
                  ml={10}
                />
              )}
            </TabletOrMobile>
          </MediaContextProvider>
        </Flex>
        <AnimatedExpandIcon isOpened={isOpened} />
      </Flex>
      {showBottomSeparator && <SectionSeparator />}
    </MenuItemWrapper>
  )
}

export default ExpandableSectionBox

const MenuItemWrapper = styled(Flex)`
  flex-direction: column;
  min-height: 50px;
  &:hover {
    cursor: pointer;
  }
  background-color: ${(props) => props.theme.colors.background};
`

const StyledBody2 = styled(Body2)`
  ${(props) => (props.highlight ? `color: ${props.theme.colors.accent};` : '')}
  margin: 15px 0;
  ${validFor.mobile`
    font-size: 14px;
`}
`
